import React  from 'react';
import { slide as Menu } from 'react-burger-menu'
import './Burger-menuStyle.scss';

export default class BurgerMenu extends React.Component {

  render () {
    // NOTE: You also need to provide styles, see https://github.com/negomi/react-burger-menu#styling
    return (
      <Menu>
        <div className="menu-item" href="/InmaculadaA">A.A. INMACULADA A - GIGAS</div>
        <div className="menu-item" href="/InmaculadaB">A.A. INMACULADA B - LZ TALLER DE ARQUITECTURA</div>
        <div className="menu-item" href="/InmaculadaFem">A.A. INMACULADA - APV</div>
      </Menu>
    );
  }
}